var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIconSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90.23 46.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.56,26.29c1.04-1,1.08-2.65.08-3.69-.04-.04-.07-.07-.11-.11-1-1.05-2.67-1.09-3.71-.08l-7.36,7.09c-.24.23-.63.06-.63-.27V2.82C70.84,1.25,69.55,0,67.98,0c-.02,0-.04,0-.06,0-1.56,0-2.82,1.27-2.82,2.82v26.56c0,.33-.4.5-.64.26l-7.19-7.33c-1.04-1.06-2.75-1.05-3.77.03-.01.01-.02.03-.04.04-.97,1.04-.96,2.65.05,3.65l12.1,12.12c1.25,1.26,3.28,1.28,4.55.05l12.39-11.91Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 45.9,
    y: 41.93,
    width: 44.33,
    height: 4.54,
    rx: 0.55,
    ry: 0.55
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIconSvg);
export default __webpack_public_path__ + "static/media/downloadIconSVG.5b53e0214c9c58c6141666e23a6138dc.svg";
export { ForwardRef as ReactComponent };